import React, { useEffect } from "react";
import "./salesAutomation.css";
import Meta from "utils/meta";
import imgLeadCapture from "assets/leadManagement-image/lead_mgmt_capture.png";
import imgLeadDigitalCampaigns from "assets/leadManagement-image/lead_mgmt_digicamp.png";
import imgLeadUniqueness from "assets/leadManagement-image/lead_mgmt_uniqueness.png";
import imgLeadView from "assets/leadManagement-image/lead_mgmt_view.png";
import imgLeadScoring from "assets/leadManagement-image/lead_mgmt_scoring.png";
import imgLeadSchedule from "assets/leadManagement-image/lead_mgmt_schedule.png";
import imgLeadCustomSales from "assets/leadManagement-image/lead_mgmt_custom_sales.png";
import SubPageHeader from "Component/SubPageHeader/subPageHeader";
import TextBlock from "Component/TextBlock/textBlock";
import ImageWithTextBlock from "Component/ImageWithTextBlock/imageWithTextBlock";
import FaqBlock from "Component/FaqBlock/faqBlock";

const LeadManagement = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const questions = [
        "What is Lead Management in Real Estate?",
        "What is Real Estate Lead Management CRM Software?",
        "How can Real Estate Lead Management CRM streamline lead generation processes?",
        "How can Realtor Desk's Lead Management CRM feature help?",
    ];

    const answers = [
        "Lead Management in Real Estate refers to organizing and tracking potential customers (leads) throughout the sales process. It helps sales representatives keep all the information in one place, making it easier to convert leads into clients.",
        "Real Estate Lead Management CRM software is a tool designed to automate and simplify the process of handling potential customers (leads) in the real estate industry. It works by capturing leads from various sources, preventing duplication of data, and providing a complete overview of each lead. ",
        "In Real Estate Lead Management CRM, getting leads becomes simpler. It collects them from different places automatically, avoids repeating the data, and helps give a full view of each lead. In addition to this, it has features like lead scoring. This makes it easier to keep everything organized and understand lead intentions better.",
        "Realtor Desk's Lead Management CRM makes things easier for real estate professionals. It automatically collects leads and ensures security with OTP verification. You get an overview of each lead and useful tools like lead scoring, appointment scheduling, tasks, and personalized sales pipelines. This simplifies the whole lead management process, making it more efficient for real estate professionals.",
    ];

    return (<>
          <Meta title="Lead Management | The Realtor Desk" description="" />
          <div className="sub-page--outer">
              <SubPageHeader
                  title="Manage Leads with Less Effort and in Less Time"
                  subTitle="Streamline lead management processes to reduce effort and time, allowing for faster response and improved conversion rates"
              />
              <div className="container">
                  <TextBlock
                        shortTitle=""
                        title="Easier Real Estate Lead Management with Realtor Desk CRM"
                        description="With sales automation, managing leads is no longer a time-consuming and energy-draining task for sales representatives. Thanks to Realtor Desk’s advanced lead management software, most of the work is automated, and the rest can be handled with just a click of a button!"
                        textSize="large"
                  />
                  <ImageWithTextBlock
                        shortTitle="Lead Capture Forms"
                        title="Automatically Capture Leads from Multiple Sources"
                        description="Realtor Desk's lead forms can be seamlessly integrated into all your digital assets, automatically gathering lead data in one central location for easy viewing and tracking."
                        image={imgLeadCapture}
                        imagePosition="right"
                        imageSize="large"
                  />
                  <ImageWithTextBlock
                      shortTitle="Capture Leads from Digital Campaigns"
                      title="Instantly Capture Leads from Digital Campaigns"
                      description="Whether it's from live chat, your landing page, social media, or search campaigns, our lead management software ensures all your leads are captured in one system. Remember, real estate buyers and investors require an instant response to stay engaged."
                      image={imgLeadDigitalCampaigns}
                      imagePosition="left"
                      imageSize="large"
                  />
                  <ImageWithTextBlock
                      shortTitle="Lead Uniqueness"
                      title="No More Wasting Time on Duplicate Data"
                      description="Lead duplication wastes time and effort. Do features a robust uniqueness check on phone numbers and email IDs, along with OTP verification, ensuring you collect valid and accurate lead data."
                      image={imgLeadUniqueness}
                      imagePosition="right"
                      imageSize="large"
                  />
                  <ImageWithTextBlock
                      shortTitle="360° Lead View"
                      title="All Your Lead Information in One Place"
                      description="Get all the details you need - conversations, past touchpoints, scheduled meetings, reminders, and more - about each lead, all in one place for easy access and efficient management."
                      image={imgLeadView}
                      imagePosition="left"
                      imageSize="large"
                  />
                  <ImageWithTextBlock
                      shortTitle="Lead Scoring"
                      title="Focus on the Right Leads"
                      description="With automatic positive and negative scoring, easily assess your leads' intent and prioritize them, helping you close sales faster and more effectively."
                      image={imgLeadScoring}
                      imagePosition="right"
                      imageSize="large"
                  />
                  <ImageWithTextBlock
                      shortTitle="Appointment, Task, Notes, Files, Follow-up"
                      title="Streamline Your Data and Tasks"
                      description="Record appointments, tasks, notes, files, and follow-ups against your leads so you never miss a detail, deadline, or meeting again. Stay organized and ensure timely follow-up with all your leads."
                      image={imgLeadSchedule}
                      imagePosition="left"
                      imageSize="large"
                  />
                  <TextBlock
                      shortTitle="Smart Views & Filters"
                      title="Get Lead Information at Your Fingertips"
                      description="You'll never have to scroll through an endless database again. Smart views and filters allow you to access leads and lead information in seconds, making your workflow more efficient."
                      textSize="small"
                  />
                  <ImageWithTextBlock
                      shortTitle="Custom Sales Pipeline"
                      title="Customize Sales Pipelines to Fit Your Business"
                      description="Create multiple sales pipelines, each customized with stages unique to your business and different developments, ensuring efficient tracking and management tailored to your needs."
                      image={imgLeadCustomSales}
                      imagePosition="left"
                      imageSize="large"
                  />
                  <FaqBlock
                      questions={questions}
                      answers={answers}
                  />
              </div>
          </div>
        </>
    );
};

export default LeadManagement;
